// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FormProviders_container__RmDIB {
  animation: FormProviders_init__rUn05 1s;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
  font-size: 1rem;
}

/*---Title---*/
.FormProviders_container__RmDIB .FormProviders_titleContainer__0F6cw {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.FormProviders_container__RmDIB .FormProviders_titleContainer__0F6cw h4 {
  width: 95%;
  text-align: center;
  font-size: 1.8rem;
  font-family: Roboto, sans-serif;
  font-weight: 300;
}

.FormProviders_container__RmDIB .FormProviders_titleContainer__0F6cw .FormProviders_arrow__THGnb {
  transition: 0.3s;
}

.FormProviders_container__RmDIB .FormProviders_titleContainer__0F6cw .FormProviders_arrow__THGnb:hover {
  transition: 0.3s;
  scale: 1.05;
  background-color: rgba(0, 0, 0, 0.05);
  border-radius: 100%;
  cursor: pointer;
}

.FormProviders_container__RmDIB .FormProviders_form__8Uwjb {
  display: flex;
  justify-content: center;
  align-items: center;
}

.FormProviders_container__RmDIB .FormProviders_form__8Uwjb .FormProviders_inputItem__F7RL3 {
  margin-bottom: 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.FormProviders_container__RmDIB .FormProviders_form__8Uwjb .FormProviders_inputItem__F7RL3 .FormProviders_cuitForm__uh3gq {
  display: flex;
  width: 80%;
  justify-content: space-evenly;
  align-items: center;
}

.FormProviders_container__RmDIB .FormProviders_form__8Uwjb .FormProviders_inputItem__F7RL3 .FormProviders_titleinput__GfuSj {
  width: 80%;
  font-size: 1.1rem;
  font-weight: 600;
  font-family: Roboto, sans-serif;
}

.FormProviders_container__RmDIB .FormProviders_form__8Uwjb .FormProviders_checkboxes__-kDJr {
  overflow-y: scroll;
  max-height: 400px;
}

.FormProviders_container__RmDIB .FormProviders_form__8Uwjb .FormProviders_check__SeHjp {
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 11vh;
  margin-bottom: 5px;
}

.FormProviders_container__RmDIB .FormProviders_form__8Uwjb .FormProviders_check__SeHjp .FormProviders_dataGame__CoizA {
  width: 95%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.FormProviders_container__RmDIB .FormProviders_form__8Uwjb .FormProviders_check__SeHjp .FormProviders_dataGame__CoizA .FormProviders_imgcontainer__xaYZl {
  width: 4rem;
  height: 4rem;
  border-radius: 100%;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0 0 15px -3px rgba(0, 0, 0, 0.268);
}

.FormProviders_container__RmDIB .FormProviders_form__8Uwjb .FormProviders_check__SeHjp .FormProviders_dataGame__CoizA .FormProviders_imgcontainer__xaYZl .FormProviders_checkImg__fS\\+XM {
  transition: 0.3s;
  font-size: 3.5rem;
  position: absolute;
}

.FormProviders_container__RmDIB .FormProviders_form__8Uwjb .FormProviders_check__SeHjp .FormProviders_dataGame__CoizA .FormProviders_imgcontainer__xaYZl .FormProviders_circle__t7maX {
  transition: 0.3s;
  font-size: 4.9rem;
  position: absolute;
}

.FormProviders_container__RmDIB .FormProviders_form__8Uwjb .FormProviders_check__SeHjp .FormProviders_dataGame__CoizA .FormProviders_imgcontainer__xaYZl img {
  transition: 0.3s;
  width: 3.9rem;
  height: 3.9rem;
  object-fit: scale-down;
  border-radius: 100%;
}
.FormProviders_container__RmDIB .FormProviders_form__8Uwjb .FormProviders_check__SeHjp .FormProviders_borderB__-wWP1 {
  margin-top: 5px;
  opacity: 0.7;
  transition: 0.3s;
  height: 1px;
}

.FormProviders_container__RmDIB .FormProviders_form__8Uwjb .FormProviders_check__SeHjp:hover .FormProviders_borderB__-wWP1 {
  transition: 0.3s;
  width: 95%;
}

.FormProviders_container__RmDIB .FormProviders_form__8Uwjb .FormProviders_check__SeHjp .FormProviders_dataGame__CoizA p {
  font-size: 1.2rem;
  font-weight: 300;
  font-family: Roboto, sans-serif;
  margin-left: 10px;
  text-transform: capitalize;
}

.FormProviders_container__RmDIB .FormProviders_form__8Uwjb p {
  font-weight: 600;
  font-size: 1.1rem;
}

.FormProviders_container__RmDIB .FormProviders_form__8Uwjb .FormProviders_label__QTGal {
  font-size: 1.2rem;
  font-weight: 300;
  display: flex;
  justify-content: center;
  align-items: center;
}

.FormProviders_container__RmDIB .FormProviders_sendButton__jq5PE {
  width: 100%;
  height: 8vh;
  display: flex;
  justify-content: center;
  margin-top: 50px;
  align-items: center;
  margin-bottom: 50px;
}

.FormProviders_container__RmDIB .FormProviders_btn__UxF98 {
  transition: 0.3s;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 25%;
  height: 90%;
  font-size: 1rem;
  border-radius: 10px;
}

.FormProviders_container__RmDIB .FormProviders_form__8Uwjb .FormProviders_titleAddress__iQZSJ {
  width: 100%;
  font-size: 1.1rem;
  font-weight: 600;
  font-family: Roboto, sans-serif;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.FormProviders_container__RmDIB .FormProviders_form__8Uwjb .FormProviders_address__DHF6X {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

@keyframes FormProviders_init__rUn05 {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Pages/Proveedores/Formulario/FormProviders.module.css"],"names":[],"mappings":"AAAA;EACE,uCAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;AACjB;;AAEA,cAAc;AACd;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,iBAAiB;EACjB,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,qCAAqC;EACrC,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,UAAU;EACV,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,iBAAiB;EACjB,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,cAAc;EACd,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,+BAA+B;EAC/B,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,UAAU;EACV,WAAW;EACX,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,+BAA+B;EAC/B,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF","sourcesContent":[".container {\n  animation: init 1s;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-top: 20px;\n  font-size: 1rem;\n}\n\n/*---Title---*/\n.container .titleContainer {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n}\n\n.container .titleContainer h4 {\n  width: 95%;\n  text-align: center;\n  font-size: 1.8rem;\n  font-family: Roboto, sans-serif;\n  font-weight: 300;\n}\n\n.container .titleContainer .arrow {\n  transition: 0.3s;\n}\n\n.container .titleContainer .arrow:hover {\n  transition: 0.3s;\n  scale: 1.05;\n  background-color: rgba(0, 0, 0, 0.05);\n  border-radius: 100%;\n  cursor: pointer;\n}\n\n.container .form {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.container .form .inputItem {\n  margin-bottom: 20px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n\n.container .form .inputItem .cuitForm {\n  display: flex;\n  width: 80%;\n  justify-content: space-evenly;\n  align-items: center;\n}\n\n.container .form .inputItem .titleinput {\n  width: 80%;\n  font-size: 1.1rem;\n  font-weight: 600;\n  font-family: Roboto, sans-serif;\n}\n\n.container .form .checkboxes {\n  overflow-y: scroll;\n  max-height: 400px;\n}\n\n.container .form .check {\n  cursor: pointer;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  height: 11vh;\n  margin-bottom: 5px;\n}\n\n.container .form .check .dataGame {\n  width: 95%;\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n}\n\n.container .form .check .dataGame .imgcontainer {\n  width: 4rem;\n  height: 4rem;\n  border-radius: 100%;\n  position: relative;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  box-shadow: 0 0 15px -3px rgba(0, 0, 0, 0.268);\n}\n\n.container .form .check .dataGame .imgcontainer .checkImg {\n  transition: 0.3s;\n  font-size: 3.5rem;\n  position: absolute;\n}\n\n.container .form .check .dataGame .imgcontainer .circle {\n  transition: 0.3s;\n  font-size: 4.9rem;\n  position: absolute;\n}\n\n.container .form .check .dataGame .imgcontainer img {\n  transition: 0.3s;\n  width: 3.9rem;\n  height: 3.9rem;\n  object-fit: scale-down;\n  border-radius: 100%;\n}\n.container .form .check .borderB {\n  margin-top: 5px;\n  opacity: 0.7;\n  transition: 0.3s;\n  height: 1px;\n}\n\n.container .form .check:hover .borderB {\n  transition: 0.3s;\n  width: 95%;\n}\n\n.container .form .check .dataGame p {\n  font-size: 1.2rem;\n  font-weight: 300;\n  font-family: Roboto, sans-serif;\n  margin-left: 10px;\n  text-transform: capitalize;\n}\n\n.container .form p {\n  font-weight: 600;\n  font-size: 1.1rem;\n}\n\n.container .form .label {\n  font-size: 1.2rem;\n  font-weight: 300;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.container .sendButton {\n  width: 100%;\n  height: 8vh;\n  display: flex;\n  justify-content: center;\n  margin-top: 50px;\n  align-items: center;\n  margin-bottom: 50px;\n}\n\n.container .btn {\n  transition: 0.3s;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 25%;\n  height: 90%;\n  font-size: 1rem;\n  border-radius: 10px;\n}\n\n.container .form .titleAddress {\n  width: 100%;\n  font-size: 1.1rem;\n  font-weight: 600;\n  font-family: Roboto, sans-serif;\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n}\n\n.container .form .address {\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n@keyframes init {\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `FormProviders_container__RmDIB`,
	"init": `FormProviders_init__rUn05`,
	"titleContainer": `FormProviders_titleContainer__0F6cw`,
	"arrow": `FormProviders_arrow__THGnb`,
	"form": `FormProviders_form__8Uwjb`,
	"inputItem": `FormProviders_inputItem__F7RL3`,
	"cuitForm": `FormProviders_cuitForm__uh3gq`,
	"titleinput": `FormProviders_titleinput__GfuSj`,
	"checkboxes": `FormProviders_checkboxes__-kDJr`,
	"check": `FormProviders_check__SeHjp`,
	"dataGame": `FormProviders_dataGame__CoizA`,
	"imgcontainer": `FormProviders_imgcontainer__xaYZl`,
	"checkImg": `FormProviders_checkImg__fS+XM`,
	"circle": `FormProviders_circle__t7maX`,
	"borderB": `FormProviders_borderB__-wWP1`,
	"label": `FormProviders_label__QTGal`,
	"sendButton": `FormProviders_sendButton__jq5PE`,
	"btn": `FormProviders_btn__UxF98`,
	"titleAddress": `FormProviders_titleAddress__iQZSJ`,
	"address": `FormProviders_address__DHF6X`
};
export default ___CSS_LOADER_EXPORT___;
